export function getEntityUpdateResponseError (response, expectedResults = null) {
  if (expectedResults === null) {
    return null
  }

  if (!Array.isArray(response) || response.length !== expectedResults) {
    return 'The backend did not confirm every scanned value.'
  }

  const failedResult = response.find(result => (
    !result
    || result.isSuccess !== true
    || result.isError === true
    || !!result.error
  ))

  if (!failedResult) {
    return null
  }

  return failedResult.error || 'The backend rejected a scanned value.'
}

export function shouldDeferEntityUpdateSubmission (options = {}, manual = false) {
  if (options.deferSubmit) {
    return true
  }

  return manual && !options.forceSubmit
}
